/**
 * Created by Administrator on 2018-09-13.
 */
export default {
  name:"",
  data(){
    return{
      phonenum:"",
      password:"",
      sendAuthCode:true,
      auth_time:0,
      imageCode:"",
      imgapiverifyCode:"",
      imgId: '',
      token:""
    }
  },
  methods:{
    /** 2018-08-22
     * author:renlinfei
     * explain:获取验证码
     */
    getAuthCode(){
      var data={
        "phonenum":this.phonenum,
        "password":this.password,
        "service":"login.SendSms",
        "channel":"network",
        "token": this.token
      }
      this.$api.post("/mstx/pr/gateway.do",data,()=>{
        this.sendAuthCode = false;
        this.auth_time = 59;
        var auth_timetimer =  setInterval(()=>{
          this.auth_time--;
          if(this.auth_time<=0){
            this.sendAuthCode = true;
            clearInterval(auth_timetimer);
          }
        }, 1000);
      });
    },
    ImageCode() {
      var data = {
        "phonenum": this.phonenum,
        "service": "login.imageCode",
        "channel": "network",
      };
      this.$api.post("/mstx/pr/gateway.do", data, (res) => {
        this.imageCode = "data:image/png;base64," + res.image;
        this.imgId = res.imgid;
      },(res)=>{
        this.$toast.fail(res.errorMsg);
      });
    },
    isCnNewID(cid) {
      var arrExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];//加权因子
      var arrValid = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];//校验码
      if (/^\d{17}\d|x$/i.test(cid)) {
        var sum = 0, idx;
        for (var i = 0; i < cid.length - 1; i++) {
          // 对前17位数字与权值乘积求和
          sum += parseInt(cid.substr(i, 1), 10) * arrExp[i];
        }
        // 计算模（固定算法）
        idx = sum % 11;
        // 检验第18为是否与校验码相等
        return arrValid[idx] == cid.substr(17, 1).toUpperCase();
      } else {
        return false;
      }
    },
  }
}
